<template>
  <div style="background-color: transparent; height: 100vh; padding: 0px">
    <h4 v-if="AreIdsShown">DASH ONE #b0c1b2</h4>
    <!-- <h6 v-if="AreIdsShown">currentSelectedSummaryWidget {{ currentSelectedSummaryWidget.id}} {{ currentSelectedSummaryWidget.name}}</h6> -->

    <div  style="background: transparent; padding: 0px; height: 100%; width: 100%; ">
      <DxSplitter width="100%" height="100%" :separator-size="0" orientation="vertical">
        <DxItem :resizable="true" :collapsible="false" size="200" :min-size="100" :max-size="400">
          <div style="background: transparent; height: 100%; width: 100%; overflow-y: auto;">
            <!-- <h6>TESTING</h6> -->
            <WidgetSummaryListPrimary />
          </div>
        </DxItem>
        <DxItem :collapsible="false">
          <DxSplitter width="100%" height="100%" :separator-size="10">
            <DxItem :resizable="false" :collapsible="false" :size="[11].includes(workListStore.currentSelectedSummaryWidget.id) ? '0' : '600'">
              <div style="background: transparent; height: 100%" v-show="![11].includes(workListStore.currentSelectedSummaryWidget.id)">
                <WidgetSummaryContainer />
              </div>
            </DxItem>
            <DxItem :resizable="true" :collapsible="false">
              <div>
                <div
                  v-show="![11].includes(workListStore.currentSelectedSummaryWidget.id) && workListStore.currentSelectedSummaryWidget.dueTextSummary"
                  style="background: transparent; padding: 0px; border-radius: 6px; width: 100%; overflow: hidden; height: 100%"
                >

                  <WidgetSummaryDetailGridPrimary
                    v-if="workListStore.currentSelectedSummaryWidget.id > 0"
                    :arrayId="workListStore.currentSelectedSummaryWidget.id"
                    :selectedFileName="workListStore.currentSelectedSummaryWidget.exportFileName"
                    idField="id"
                  />
                </div>
                <div
                  v-show="[11].includes(workListStore.currentSelectedSummaryWidget.id)"
                  style="background: transparent; padding: 0px; border-radius: 6px; width: 100%; overflow: hidden; height: 100%"
                >
                  <WidgetSummaryMeasuresContainer />
                </div>
              </div>
            </DxItem>
          </DxSplitter>
        </DxItem>
      </DxSplitter>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, computed, watch, onMounted, toRaw } from "vue";

import { useStoreWorkList } from "@/stores/workListsStore";

import { DxSplitter, DxItem } from "devextreme-vue/splitter";


import WidgetSummaryListPrimary from "@/modules/WorkLists/WidgetSummaryListPrimary.vue";
import WidgetSummaryContainer from "@/modules/WorkLists/WidgetSummaryContainer.vue";
import WidgetSummaryDetailGridPrimary from "@/modules/WorkLists/WidgetSummaryDetailGridPrimary.vue";

import WidgetSummaryMeasuresContainer from "@/modules/WorkLists/WidgetSummaryMeasuresContainer.vue";

const AreIdsShown = ref(false);
const workListStore = useStoreWorkList();

onMounted(() => {
  // console.clear()
  // console.log(" 		DASHBOARD PAGE ONE");
  // console.log(" 		currentSelectedSummaryWidget");
  // console.log(workListStore.currentSelectedSummaryWidget);
  // console.log(workListStore.selectedWidgetDetail);
});
</script>

<style lang="scss" scoped>
.btn {
  &:hover + .box {
    transform: scale(2);
  }
}

.btn.selected {
  color: red;
}

.box {
  transition: transform 330ms ease-in-out;
}

.btn-secondary:hover {
  color: #17b3be;
  background-color: #1adb23;
  transform: scale(1.4);
  transition: transform 330ms ease-in-out;
}

.transform-me {
  margin-left: 100px;
}

.transform-me:hover {
  transform: scale(1.2);
}

#bFormContainer {
  background: rgba(0, 255, 234, 0.645);
  padding: 13px;
  width: 50%;
  height: 50%;
  overflow: auto;
  border-radius: 25px;
}

#tagContainer {
  background: rgb(55, 65, 65);
  padding: 3px;
  height: 83vh;
  border: 3px solid orange;
  padding: 10px;
  border-radius: 25px;
}

.visibleA {
  visibility: visible;
  opacity: 1;
  transition: opacity 2s linear;
}

.hiddenA {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.25);
  }

  100% {
    transform: scale(1);
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.my-custom-tags-list1 {
  background: #ffea08;
  border: 3px solid rgb(230, 5, 207);
  color: #007bff;
  padding: 10px;
  width: 666px;
}

.three-pane-wrapper {
  border-top: 1px black solid;
  min-height: 800px;
}

.vertical-panes {
  width: 100%;
  height: 400px;
  border: 1px solid red;
}

.vertical-panes > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #842d2d;
}

.vertical-panes > .pane ~ .pane {
  border-left: 1px solid #34db06;
}

.custom-resizer {
  width: 100%;
  height: 72vh;
}

.custom-resizer > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #c6d9c8;
  border: 1px solid #ccc;
}

.custom-resizer > .pane ~ .pane {
  background: #c6d9c8;
}

.custom-resizer > .MultipaneResizer {
  margin: 0;
  left: 0;
  position: relative;

  &:before {
    display: block;
    content: "";
    width: 3px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -1.5px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ff0101;
  }

  &:hover {
    &:before {
      border-color: #999;
    }
  }
}
</style>
